/**
 * This component is a resolver. It is meant to be used by page templates using
 * data from a CMS.
 *
 * You can send the data you receive from the CMS to the props of this components
 * by spreading them (like <ListOfSubpages {...cmsData} />)
 * and then make these props fit the final module.
 *
 * Note that propTypes are not needed in this component: the GraphQL schema
 * definition is sufficient for that matter.
 */
import React from "react"
import { graphql } from "gatsby"
import { Section } from "@bw/bits"
import { ListOfSubpages as ListOfSubpagesModule } from "@bw/modules"
// parse is used to ensure that HTML sent by the CMS is converted to React components

const ListOfSubpages = ({
  suptitle,
  title,
  subtitle,
  button,
  buttonPosition,
  idAttribute,
  classAttribute,
  backgroundVariant,
  isFollowedByModuleWithBackgroundVariant,
  childNodes,
  numberOfColumns,
}) => {
  if (typeof window !== "undefined") {
    const urlParams = new URLSearchParams(window.location.search)
    const preview = urlParams.get("live-preview")

    if (preview) {
      return (
        <Section
          {...{
            suptitle,
            title,
            subtitle,
            button,
            buttonPosition,
            idAttribute,
            classAttribute,
            backgroundVariant,
            isFollowedByModuleWithBackgroundVariant,
          }}
        >
          <div style={{ textAlign: "center", color: "red" }}>
            Le module Liste de sous-pages ne peut pas être prévisualisé.
          </div>
        </Section>
      )
    }
  }

  return (
    <Section
      {...{
        suptitle,
        title,
        subtitle,
        button,
        buttonPosition,
        idAttribute,
        classAttribute,
        backgroundVariant,
        isFollowedByModuleWithBackgroundVariant,
      }}
    >
      <ListOfSubpagesModule
        subpages={childNodes.nodes}
        numberOfColumns={numberOfColumns.value ?? 3}
      />
    </Section>
  )
}

/**
 * This generates a GraphQL Fragment that can be used in a page query:
 *
 * Example:
 *   ...ListOfSubpagesModuleFragment
 *
 * This is also what you will get in the props of your ListOfSubpages
 * resolver component.
 */
export const query = graphql`
  fragment ListOfSubpagesModuleFragment on ListOfSubpagesModule {
    numberOfColumns {
      value
    }
  }
`

export { ListOfSubpages }
